var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcnDuplicate = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M14.454 2.91v4.545h5v9.09h-4.46l.036.91h5.333V6.675L14.78 2H8.545v5.324h.91V2.91zm.91.908 3.272 2.727h-3.272z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M9.455 12V7.455h-4.49L4.909 21.09h9.945V12zm6.363-.78V22H4V6.545h6.234zm-1.636-.13L10.364 7.91v3.182z",
  clipRule: "evenodd"
})));
export default SvgIcnDuplicate;